module.exports = __webpack_public_path__ + "static/media/czhdIMG2.75765405.png";